/**
 * The menu bar's theme toggle (A-19): flips between the default dark and light
 * themes through `theme.set`. Window › Theme and Preferences list every theme.
 */
import { defaultThemeFor } from "../../themes";
import { useEditor } from "../EditorContext";
import { useTheme } from "../hooks/editorHooks";
import { MoonIcon, SunIcon } from "../ui/icons";

export function ThemeToggle() {
  const { dispatch } = useEditor();
  const theme = useTheme();
  const next = defaultThemeFor(theme.mode === "dark" ? "light" : "dark");
  const Icon = theme.mode === "dark" ? SunIcon : MoonIcon;

  return (
    <button
      type="button"
      className="kn-menubar__theme"
      aria-label={`Switch to ${next.name} theme`}
      title={`Switch to ${next.name} theme`}
      onClick={() => void dispatch({ type: "theme.set", payload: { id: next.id }, origin: "menu" })}
    >
      <Icon size={14} />
    </button>
  );
}
